<template>
  <expert-layout>
    <v-layout wrap>
      <v-flex xs12 class="mx-3">
        
        <v-toolbar flat dense class="toolbarColor">
          <v-icon>list</v-icon>My Video Projects
          <v-spacer></v-spacer>
          <v-btn round dark small class="btnColor" to="/expert/create/video_project" v-if="packageItem.video_projects>videoProjects.length">
            <v-icon left>add</v-icon>Add Video project
          </v-btn>
        </v-toolbar>
      </v-flex>
     <!-- projects -->
      <v-flex xs12 class="list-section text-xs-center mt-3 mx-3">
        <v-alert
          :value="true"
          type="info"
        >You can add a maximum of {{packageItem.video_projects}} videos under this package.</v-alert>
      </v-flex>
      <!-- end  -->
      <video-projects-list :videoProjects="loadVideoProjects"></video-projects-list>
    </v-layout>
    <v-pagination class="ml-2 mt-2" v-if="videoProjects.length>=1"
        v-model="currentPage"
        :length="Math.ceil(videoProjects.length/perPage)"
    ></v-pagination>
  </expert-layout>
</template>

<script>
import ExpertVideoProjectsMenu from "./_components/projects_menu.vue";
import VideoProjectsList from "./_components/projects_list.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ExpertVideoProjectsIndex",
  components: {
    ExpertVideoProjectsMenu,
    VideoProjectsList
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["videoProjectsNo"]),
    loadVideoProjects() {
      return this.videoProjects.slice((this.currentPage*this.perPage - this.perPage), ((this.currentPage*this.perPage - this.perPage)+this.perPage))
    }
  },
  data() {
    return {
      videoProjects: [],
      currentPage: 1,
      perPage: 9,
      subscription: {},
      packageItem: {}
    };
  },
  methods: {
    getUser() {
      const self = this;
      this.$store.dispatch("get", "/user/" + this.user._id).then(res => {
        if (res.state) {
          const expert = res.user;
          this.subscription = res.subscription;
          if (expert.expired == true) {
            self.$router.push("/expiry");
          }
          const resPackage = this.$store
            .dispatch("get", "/packages/" + this.subscription.packageId)
            .then(res => {
              this.packageItem = res.packageItem;
            });
        }
      });
    },
    getVideoProjects() {
      this.$store.dispatch("get", "/videoproject/fetch/" + this.user._id).then(res => {
      this.videoProjects = res.projects;
    });
    }
  },
  created() {
    this.getUser();
    this.getVideoProjects();
  }
};
</script>
